import { Action } from '@ngrx/store';
import {Region, REGIONS, StateUtils} from '@spartacus/core';

export const LOAD_REGIONS = '[User] Load Regions By Zone';
export const LOAD_REGIONS_SUCCESS = '[User] Load Regions By Zone Success';
export const LOAD_REGIONS_FAIL = '[User] Load Regions By Zone Fail';
export const CLEAR_REGIONS = '[User] Clear Regions By Zone';

export class LoadRegions extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_REGIONS;
  constructor(public payload: {
    countryIsoCode: string,
    zone?: string
  }) {
    super(REGIONS);
  }
}

export class LoadRegionsFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_REGIONS_FAIL;
  constructor(public payload: any) {
    super(REGIONS, payload);
  }
}

export class LoadRegionsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_REGIONS_SUCCESS;
  constructor(public payload: { entities: Region[]; country: string; zone: string }) {
    super(REGIONS);
  }
}

export class ClearRegions implements Action {
  readonly type = CLEAR_REGIONS;
  constructor() {}
}

export type CustomRegionsAction =
  | LoadRegions
  | LoadRegionsFail
  | LoadRegionsSuccess
  | ClearRegions;
